export default __webpack_public_path__ + "static/media/switch-certificate-icon.283dd36e.svg";